import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};

// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    //bottom
    // {
    //     cameraLocationId: 'STAND_TEST01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'Stand Test',
    //     ObjectId:null,
    //     displayMesh: 'N',
    // },

    // {
    //     cameraLocationId: 'topStairsCameraLocation_id',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'Top Stairs Area',
    //     ObjectId:null,
    //     displayMesh: 'N',
    // },
    // {
    //     cameraLocationId: 'bottomStairsCameraLocation_id',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'Ground Stairs Area',
    //     ObjectId:null,
    //     displayMesh: 'N',
    // },
    {
        // ToDo: See the two videos from here!! New!! Initial Camera Position
        cameraLocationId: 'ENTRENCE_VIDEO',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'WELCOME',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'bottomStairsCameraLocation_id',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'GROUND FLOOR',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationLevel2Id: ['ENTRENCE_VIDEO','ZONE11', 'ZONE12', 'ZONE13', 'ZONE14', 'ZONE15', 'ZONE16', 'ZONE17']
    },
    {
        cameraLocationId: 'ZONE_BOTTOM_CORRIDOR',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'MArch Dissertations',
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ZONE11',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Student Intiatives',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE12',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Unlearning… How to Practice Architecture?',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE13',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Material Change',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE14',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Re-mapping the Neo Avant Garde',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE15',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Archive of the Collective Interior',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE16',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Edge Conditions',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE17',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'The Big Here and The Long Now',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },

    // {
    //     cameraLocationId: 'ENTRENCE_VIDEO',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: 'Entrance Video',
    //     ObjectId:null,
    //     displayMesh: 'Y',
    // },

    //Top
    {
        cameraLocationId: 'topStairsCameraLocation_id',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'FIRST FLOOR',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationLevel2Id: ['ZONE01', 'ZONE02', 'ZONE03', 'ZONE04', 'ZONE05', 'ZONE06', 'ZONE07', 'ZONE08', 'ZONE09', 'ZONE10']
    },
    {
        cameraLocationId: 'ZONE01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'A Manifesto for Housing',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'City Ruins',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Ghost in the Machine',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'House of Memories',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Weaving in Wallsend',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Building upon Building',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE07',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Creative Synergies',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE08',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Curating the City',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE09',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Architecture and Urban Planning',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'ZONE10',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Stages 1 and 2',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
    {
        //ToDo: Add a new Camera Location!!
        cameraLocationId: 'ZONE10-2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'BA Dissertations',
        ObjectId:null,
        displayMesh: 'N',
        // cameraLocationIdOfChild: 'Y',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
